import type { RegisterSpaceSettlement, SpaceLedger } from '@/types/space-settlements';
import { transferKey } from './settlement';

export interface SettlementDraft {
  selected: string[];
  request: RegisterSpaceSettlement | null;
  phase: 'select' | 'pending' | 'uncertain' | 'conflict' | 'blocked';
  error: string | null;
}
export type SettlementAction =
  | { type: 'toggle'; key: string }
  | { type: 'submit'; request: RegisterSpaceSettlement }
  | { type: 'failure'; phase: 'uncertain' | 'conflict' | 'blocked' | 'select'; error: string }
  | { type: 'reset'; ledger: SpaceLedger; userId: string };

export function initialSettlementDraft(ledger: SpaceLedger, userId: string, request: RegisterSpaceSettlement | null = null): SettlementDraft {
  return { selected: (request?.transfers ?? ledger.suggestedTransfers.filter((transfer) => transfer.fromUserId === userId || transfer.toUserId === userId)).map(transferKey),
    request, phase: request ? 'uncertain' : 'select', error: request ? 'Há um registro sem confirmação nesta sessão. Verifique o resultado usando o mesmo pedido.' : null };
}

export function settlementDraftReducer(state: SettlementDraft, action: SettlementAction): SettlementDraft {
  switch (action.type) {
    case 'toggle': return state.phase !== 'select' ? state : { ...state, selected: state.selected.includes(action.key) ? state.selected.filter((key) => key !== action.key) : [...state.selected, action.key] };
    case 'submit': return { ...state, phase: 'pending', request: action.request, error: null };
    case 'failure': return { ...state, phase: action.phase, error: action.error, request: ['select', 'conflict'].includes(action.phase) ? null : state.request };
    case 'reset': return initialSettlementDraft(action.ledger, action.userId);
  }
}

export function settlementStorageKey(userId: string, spaceId: string, period: string): string {
  return `space-settlement-pending:${JSON.stringify([userId, spaceId, period])}`;
}

export function readPendingSettlement(key: string): RegisterSpaceSettlement | null {
  try {
    const stored: unknown = JSON.parse(sessionStorage.getItem(key) ?? 'null');
    if (!stored || typeof stored !== 'object') return null;
    const request = stored as RegisterSpaceSettlement;
    if (typeof request.periodKey !== 'string' || typeof request.ledgerVersion !== 'string' || typeof request.requestKey !== 'string'
      || !Array.isArray(request.transfers) || !request.transfers.length
      || !request.transfers.every((transfer) => transfer && typeof transfer.fromUserId === 'string' && typeof transfer.toUserId === 'string' && Number.isSafeInteger(transfer.amountCents) && transfer.amountCents > 0)) return null;
    return request;
  } catch { return null; }
}
